import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { processChildrenWithCitations } from './CaseReference';

function MarkdownViewer({ content, title, onCaseClick }) {
  // Custom markdown components that process citations
  const markdownComponents = useMemo(() => {
    if (!onCaseClick) return {};

    return {
      p: ({ children, ...props }) => (
        <p {...props}>{processChildrenWithCitations(children, onCaseClick)}</p>
      ),
      li: ({ children, ...props }) => (
        <li {...props}>{processChildrenWithCitations(children, onCaseClick)}</li>
      ),
      strong: ({ children, ...props }) => (
        <strong {...props}>{processChildrenWithCitations(children, onCaseClick)}</strong>
      ),
      em: ({ children, ...props }) => (
        <em {...props}>{processChildrenWithCitations(children, onCaseClick)}</em>
      ),
      td: ({ children, ...props }) => (
        <td {...props}>{processChildrenWithCitations(children, onCaseClick)}</td>
      ),
      th: ({ children, ...props }) => (
        <th {...props}>{processChildrenWithCitations(children, onCaseClick)}</th>
      )
    };
  }, [onCaseClick]);

  return (
    <div className="markdown-viewer">
      <div className="markdown-content prose prose-invert max-w-none">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={markdownComponents}
        >
          {content}
        </ReactMarkdown>
      </div>

      <style>{`
        .markdown-viewer {
          height: 100%;
          display: flex;
          flex-direction: column;
          background: rgba(30, 27, 75, 0.8);
          border-radius: 8px;
          overflow: hidden;
        }
        .markdown-content {
          flex: 1;
          overflow-y: auto;
          padding: 1.5rem;
        }
      `}</style>
    </div>
  );
}

export default MarkdownViewer;
